import React, { useEffect, useState } from "react";
import Spinner from "./Spinner";

/**
 * Lazy-loaded CKEditor. Ships in a separate bundle chunk (~450 KB
 * uncompressed) so AddBuild / BuildDetails don't block their initial
 * paint on it.
 *
 * Props mirror the upstream @ckeditor/ckeditor5-react <CKEditor /> —
 * { data, onChange, onReady, disabled, config }.
 *
 * While the chunk is resolving, renders a Spinner inline. After that,
 * renders the real CKEditor.
 */
const LazyCKEditor = (props) => {
    const [deps, setDeps] = useState(null); // { CKEditor, ClassicEditor }

    useEffect(() => {
        let cancelled = false;
        Promise.all([
            import("@ckeditor/ckeditor5-react"),
            import("@ckeditor/ckeditor5-build-classic"),
        ]).then(([reactMod, buildMod]) => {
            if (cancelled) return;
            setDeps({
                CKEditor: reactMod.CKEditor,
                ClassicEditor: buildMod.default || buildMod,
            });
        });
        return () => {
            cancelled = true;
        };
    }, []);

    if (!deps) {
        return (
            <div style={{ padding: "24px 0" }}>
                <Spinner size={32} label="Loading editor…" />
            </div>
        );
    }

    const { CKEditor, ClassicEditor } = deps;
    return <CKEditor editor={ClassicEditor} {...props} />;
};

export default LazyCKEditor;
